import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { connectWithSocketIOServer } from "./utils/wss";
import IntroductionPage from "./IntroductionPage/IntroductionPage";
import JoinRoomPage from "./JoinRoomPage/JoinRoomPage";
import RoomPage from "./RoomPage/RoomPage";
import "./App.css";

function App() {
  useEffect(() => {
    connectWithSocketIOServer();
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={IntroductionPage} />
        <Route path="/join-room" component={JoinRoomPage} />
        <Route path="/room" component={RoomPage} />
      </Switch>
    </Router>
  );
}

export default App;
